import { Box, Card, CardContent, Chip, Stack, Typography } from "@mui/material";

const formatDateTime = (date) =>
  date
    ? new Date(date).toLocaleString(undefined, { timeZoneName: "short" })
    : null;

// Admin view of wrong pickup / delivery codes the seller entered on this
// order (utility/handoverOtp.js in the backend). A seller cycling through
// lockouts may be guessing to complete a handover the buyer never attended;
// a blocked order needs a REOPENED resolution to get a new code.
const OrderHandoverAttempts = ({ order }) => {
  const attempts = order.otpAttempts;
  const log = attempts?.log || [];
  if (!log.length && !attempts?.blockedAt) return null;
  const progress = order.handoverCodeProgress;

  return (
    <Card variant="outlined" sx={{ mb: 2 }}>
      <CardContent>
        <Stack direction="row" spacing={1} alignItems="center" mb={1}>
          <Typography fontWeight={600}>Wrong handover codes</Typography>
          {attempts.blockedAt ? (
            <Chip size="small" color="error" label="Code entry blocked" />
          ) : progress?.lockedUntil ? (
            <Chip size="small" color="warning" label="Locked" />
          ) : null}
        </Stack>
        <Typography variant="body2" mb={1}>
          {log.length} wrong {log.length === 1 ? "code" : "codes"} entered,{" "}
          {attempts.lockouts || 0}{" "}
          {attempts.lockouts === 1 ? "lockout" : "lockouts"}.
          {attempts.blockedAt
            ? ` Blocked ${formatDateTime(attempts.blockedAt)}. Resolve a dispute as REOPENED to issue a new code.`
            : progress?.lockedUntil
              ? ` Locked until ${formatDateTime(progress.lockedUntil)}.`
              : ""}
        </Typography>
        <Box component="ul" sx={{ m: 0, pl: 2.5 }}>
          {[...log].reverse().map((entry, i) => (
            <Typography component="li" variant="caption" key={i}>
              {formatDateTime(entry.at)} ·{" "}
              {entry.kind === "DELIVERY" ? "Delivery" : "Pickup"} code
            </Typography>
          ))}
        </Box>
      </CardContent>
    </Card>
  );
};

export default OrderHandoverAttempts;
